export enum Task {
  DEVELOPMENT = "DEVELOPMENT",
  ORGANIZATION = "ORGANIZATION",
  PROJECT = "PROJECT",
  USABILITY = "USABILITY",
}
